<template>
    <transition name="fade" appear>
        <section class="gz-add-shelter" :class="{'gz-add-shelter_saved':savedComputed}"> 
        
            <!-- Блок с краткой информацией -->
            <section class="gz-add-shelter__short-info" @click="showShelterEdit = !showShelterEdit, setConstruction()">
                <div class="gz-add-shelter__counter">
                    <span v-if="single" class="icon-d"></span>
                    <span v-else>{{ counter }}</span>
                </div>

                <div v-if="shelters.ownerLastName.value" class="gz-add-shelter__short-info__owner">
                    <span><strong>Владелец:</strong></span>
                    <span>&nbsp;{{ shelters.ownerLastName.value }}&nbsp;</span>
                    <span>&nbsp;{{ shelters.ownerName.value }}&nbsp;</span>
                    <span>&nbsp;{{ shelters.ownerMiddleName.value }}</span>
                </div>

                <div v-else class="gz-add-shelter__short-info__note">
                    <span>Добавить помещение</span>
                </div>
                                        
                <div class="gz-add-shelter__short-porch">
                    <span v-if="shelters.porch" class="gz-add-shelter__short-info__porch"><strong>Подъезд:</strong>&nbsp;{{ shelters.porch.value }}</span>
                    <span v-if="shelters.level" class="gz-add-shelter__short-info__floor"><strong>Этаж:&nbsp;</strong>{{ shelters.level.value }}</span>
                    <span v-if="shelters.number" class="gz-add-shelter__short-info__flat"><strong>Квартира:&nbsp;</strong>{{ shelters.number.value }}</span>
                </div>

                <div
                    v-if="!savedComputed"
                    class="gz-icon_cercle gz-icon_cercle_default"
                    @click.stop="$emit('delete')">
                    <span class="icon-bin"></span>
                </div>
            </section>
            
            <!-- Выпадающий блок редактирования -->
            <transition name="fade-in" appear>
                <section v-if="showShelterEdit" ref="Shelter" class="gz-add-shelter__container"> 
                    <section class="gz-add-shelter__owners">
                        <gz-input-container
                            label="Фамилия"
                            class="gz-input-container_default"
                            :required="true"
                        >
                            <GZ-TextInput
                                class="gz-text-input_dark"
                                @value="shelters.ownerLastName.value = $event"
                                :importedData="shelters.ownerLastName.value"
                            />
                        </gz-input-container>
                        
                        <gz-input-container
                            label="Имя"
                            class="gz-input-container_default"
                            :required="true"
                        >
                            <GZ-TextInput
                                class="gz-text-input_dark"
                                @value="shelters.ownerName.value = $event"
                                :importedData="shelters.ownerName.value"
                            />
                        </gz-input-container>
                        
                        <gz-input-container
                            label="Отчество"
                            class="gz-input-container_default"
                        >
                            <GZ-TextInput
                                class="gz-text-input_dark"
                                @value="shelters.ownerMiddleName.value = $event"
                                :importedData="shelters.ownerMiddleName.value"
                            />
                        </gz-input-container>

                        <gz-input-container
                            label="Электронная почта"
                            class="gz-input-container_default"
                        >
                            <GZ-TextInput
                                class="gz-text-input_dark"
                                @value="shelters.ownerEmail.value = $event"
                                :importedData="shelters.ownerEmail.value"
                            />
                        </gz-input-container>
                        
                        <gz-input-container
                            label="Телефон"
                            class="gz-input-container_default"
                        >     
                            <input 
                                class="gz-text-input gz-text-input_dark" 
                                type="text" 
                                v-mask="'+# (###)-###-##-##'"
                                placeholder="+7 (111) 111-11-11"
                                v-model="shelters.ownerPhone.value"
                            >
                        </gz-input-container>
                    </section>
                    
                    <GZ-BlockTitle title="Локация"/>
                    
                    <gz-input-container
                        label="Подъезд"
                        class="gz-input-container_default"
                    >
                        <GZ-TextInput
                            class="gz-text-input_dark"
                            :importedData="shelters.porch.value"
                            @value="shelters.porch.value = $event"
                        />
                    </gz-input-container>
                    
                    <gz-input-container
                        label="Этаж"
                        class="gz-input-container_default"
                    >
                        <GZ-TextInput
                            class="gz-text-input_dark"
                            :importedData="shelters.level.value"
                            @value="shelters.level.value = $event"
                        />
                    </gz-input-container>
                    
                    <gz-input-container
                        label="Номер квартиры"
                        class="gz-input-container_default"
                    >
                        <GZ-TextInput
                            class="gz-text-input_dark"
                            :importedData="shelters.number.value"
                            @value="shelters.number.value = $event"
                        />
                    </gz-input-container>

                    <GZ-BlockTitle title="Характеристики"/>

                    <gz-input-container
                        label="Сечение"
                        class="gz-input-container_default"
                    >
                        <GZ-TextInput
                            class="gz-text-input_dark"
                            :importedData="shelters.size.value"
                            @value="shelters.size.value = $event"
                        />
                    </gz-input-container>
                    
                    <gz-input-container
                        label="Стояк"
                        class="gz-input-container_default"
                    >
                        <GZ-TextInput
                            class="gz-text-input_dark"
                            :importedData="shelters.riser.value"
                            @value="shelters.riser.value = $event"
                        />
                    </gz-input-container>
                    
                    <gz-input-container
                        label="Вентиляционные каналы"
                        class="gz-input-container_default"
                    >
                        <GZ-TextInput
                            class="gz-text-input_dark"
                            :importedData="shelters.fanCanal.value"
                            @value="shelters.fanCanal.value = $event"
                        />
                    </gz-input-container>
                    
                    <gz-input-container
                        label="Дымовой канал"
                        class="gz-input-container_default"
                    >
                        <GZ-TextInput
                            class="gz-text-input_dark"
                            :importedData="shelters.smokeCanal.value"
                            @value="shelters.smokeCanal.value = $event"
                        />
                    </gz-input-container>
                    
                    <GZ-BlockTitle title="Материал воздуховодов"/>

                    <section style="margin-bottom: 20px">
                        <span class="gz-option-select__item_title">Материал воздуховодов</span>
                            <div 
                                v-for="(item, index) in shelters.constructionList"
                                :key="index" 
                                class="gz-option-select__item">
                                <GZ-OptionSelect
                                    :value="item.name" 
                                    :checked="item.selected ? true : false"
                                    @update:select="shelters.constructionList[index].selected = $event"
                                />
                            </div>
                    </section>

                    <section style="margin-bottom: 20px">
                        <span class="gz-option-select__item_title">Комментарий к материалу</span>
                        <div class="gz-textarea">
                            <textarea 
                                class="gz-text-input_dark" 
                                v-model="shelters.constructionDescr" 
                                rows="5" 
                                style="width: 100%"
                            ></textarea>
                        </div>
                    </section>

                    <GZ-BlockTitle title="Газовый счетчик"/>
                    
                    <InputDublicateBlock 
                        descr="Счетчик"
                        :items="shelters.gasCounterList"
                    />
                    
                    <GZ-BlockTitle title="Газовый котел"/>

                    <InputDublicateBlock 
                        type="Тип газового котла"
                        descr="Название газового котла"
                        :types="boilerTypeList"
                        :items="shelters.boilerList"
                    />                    
                    
                    <GZ-BlockTitle title="Газовая колонка"/>

                    <InputDublicateBlock 
                        type="Тип газовой колонки"
                        descr="Название газовой колонки"
                        :types="waterHeaterTypeList"
                        :items="shelters.waterHeaterList"
                    />                                           

                    <GZ-BlockTitle title="Газовая плита"/>

                    <InputDublicateBlock 
                        type="Тип газовой плиты"
                        descr="Название газовой плиты"
                        :types="stoveTypeList"
                        :items="shelters.stoveList"
                    />
                    
                    <GZ-BlockTitle title="Дата следующей проверки"/>

                    <gz-input-container 
                        label="Укажите дату"
                        class="display-iblock w-auto"    
                    >
                        <GZ-DateInput 
                            @dateValue="shelters.nextCheckupDate.value = $event" 
                            :value="shelters.nextCheckupDate.value"
                            class="gz-date-input_no-border gz-date-input_calend-up gz-date-input_dark"
                        />
                    </gz-input-container>

                    <section class="gz-block-controls">
                        <GZ-BaseButton 
                            :value="items.attributes || this.single ? 'сохранить изменения' : 'сохранить помещение'" 
                            icon="icon-floppy-disk"
                            class="gz-button_default gz-button_save-address"
                            :loading="loading"
                            @click="items.attributes || single ? editShelter() : saveShelter()"/>
                        
                        <GZ-BaseButton
                            v-if="!items.attributes && !this.single"
                            value="удалить" 
                            icon="icon-bin"
                            class="gz-button_default gz-button_remove-default"
                            @click="$emit('delete')"/>
                    </section>
                </section> <!-- gz-add-shelter__container -->
            </transition>
        </section> <!-- gz-add-shelter -->
    </transition>
</template>

<script>
import InputDublicateBlock from '@/components/ui/forms/InputDublicateBlock'

export default {
    name: 'AdminAddShelter',

    components: {
        InputDublicateBlock
    },
    props: {
        counter: Number,
        items: {
            type: [Object, Number],
            default: () => ({})
        },
        single: {
            //Если отдельная старница помещения
            type: Boolean,
            default: false
        },
        id: String //Передается если отдельная страница
    },
    data() {
        return {
            shelters: {
                profid: '',
                bid: '',
                ownerName: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                ownerLastName: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                ownerMiddleName: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                ownerEmail: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                ownerPhone: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                porch: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                level: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                number: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                riser: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                size: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                fanCanal: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                smokeCanal: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                },
                constructionList: [],
                constructionDescr: '',
                gasCounterList: {
                    value: [],
                    buffer: {},
                    bufferDescr: ''                 
                },
                boilerList: {
                    value: [],
                    buffer: {},                    
                    bufferDescr: ''                   
                },
                waterHeaterList: {
                    value: [],
                    buffer: {},                    
                    bufferDescr: ''                   
                },
                stoveList: {
                    value: [],                    
                    buffer: {},                    
                    bufferDescr: ''                    
                },
                nextCheckupDate: {
                    value: '',
                    valid: true,
                    validationMessage: ''
                }
            },

            showShelterEdit: false,
            saved: false,
            loading: false
        }
    },
    computed: {
        savedComputed() {
            //Индикатор того, что помещение сохранено
            return this.saved
        },
        boilerTypeList() {
            return this.$store.getters['filterBoilerType']
        },
        stoveTypeList() {
            return this.$store.getters['filterStoveType']
        },
        waterHeaterTypeList() {
            return this.$store.getters['filterWaterHeaterType']
        }
    },
    mounted() {
        if (this.single) {
            //Если на отдельной странице помещения
            this.saved = true            
            
            this.$store.dispatch('addressesGetShelter', this.id)
                .then(() => {                    
                    this.getAttributes(this.$store.getters['addressesShelter'].attributes)
                })
                .then(() => {
                    this.$store.dispatch('addressesGetUser', this.$store.getters['addressesShelter'].attributes.profid)
                        .then(() => {                            
                            this.getProfileAttributes(this.$store.getters['addressesUser'])
                        })
                })
        } else {
            if (this.items.attributes) {
                //Если на странице редактирования адреса и помещений в нем
                this.saved = true

                this.getAttributes(this.items.attributes)                

                this.$store.dispatch('addressesGetUser', this.items.attributes.profid)
                    .then(() => {                        
                        this.getProfileAttributes(this.$store.getters['addressesUser'])
                    })
            }
        }
    },
    methods: {
        getProfileAttributes(data) {
            this.profid = data.id
            this.shelters.ownerLastName.value = data.attributes.lname
            this.shelters.ownerName.value = data.attributes.fname
            this.shelters.ownerMiddleName.value = data.attributes.pname
            this.shelters.ownerEmail.value = data.attributes.email
            this.shelters.ownerPhone.value = data.attributes.phone
        },
        getAttributes(data) {
            this.shelters.profid = data.profid
            this.shelters.bid = data.bid

            this.shelters.porch.value = data.porch
            this.shelters.level.value = data.level
            this.shelters.number.value = data.number
            this.shelters.riser.value = data.riser
            this.shelters.size.value = data.size
            this.shelters.fanCanal.value = data.vk
            this.shelters.smokeCanal.value = data.dk

            //Чекбоксы материалы
            this.shelters.constructionList = JSON.parse(JSON.stringify(this.$store.getters['filtersBuildingMaterial']))
            
            this.shelters.constructionList.forEach((item_1, index) => {
                data.construction.forEach(item_2 => {
                    if (item_1.value === item_2) {
                        item_1.selected = true
                    }
                })
            })

            this.shelters.constructionDescr = data.constructionDescr

            if (data.gasCounterList.length) {
                data.gasCounterList.forEach((item, index) => {
                    this.shelters.gasCounterList.value.push({descr: item.descr})
                })
            }

            if (data.boilerList.length) {
                data.boilerList.forEach((item, index) => {
                    this.shelters.boilerList.value.push({
                        type: {
                            name: this.enumFilterMap('get', item.type, this.$store.getters['filterBoilerType']),
                            value: item.type
                        },
                        descr: item.descr
                    })
                })
            }

            if (data.waterHeaterList.length) {
                data.waterHeaterList.forEach((item, index) => {
                    this.shelters.waterHeaterList.value.push({
                        type: {
                            name: this.enumFilterMap('get', item.type, this.$store.getters['filterWaterHeaterType']),
                            value: item.type
                        },
                        descr: item.descr
                    })
                })
            }

            if (data.stoveList.length) {
                data.stoveList.forEach((item, index) => {
                    this.shelters.stoveList.value.push({
                        type: {
                            name: this.enumFilterMap('get', item.type, this.$store.getters['filterStoveType']),
                            value: item.type
                        },
                        descr: item.descr
                    })
                })
            }

            this.shelters.nextCheckupDate.value = data.nextCheckupDate
        },
        setAttributes() {
            let construction = []
            this.shelters.constructionList.forEach(item => {
                if (item.selected === true) {
                    construction.push(item.value)
                }
            })

            let gasCounterList = []
            let boilerList = []
            let waterHeaterList = []
            let stoveList = []

            this.shelters.gasCounterList.value.forEach(item => {
                gasCounterList.push({descr: item.descr})
            })
            
            this.shelters.boilerList.value.forEach(item => {
                boilerList.push({type: item.type.value, descr: item.descr})
            })

            this.shelters.waterHeaterList.value.forEach(item => {
                waterHeaterList.push({type: item.type.value, descr: item.descr})
            })

            this.shelters.stoveList.value.forEach(item => {
                stoveList.push({type: item.type.value, descr: item.descr})
            })

            return {
                porch: this.shelters.porch.value,
                level: this.shelters.level.value,
                number: this.shelters.number.value,

                riser: this.shelters.riser.value,
                size: this.shelters.size.value,
                dk: this.shelters.smokeCanal.value,
                vk: this.shelters.fanCanal.value,
                
                construction: construction,
                constructionDescr: this.shelters.constructionDescr,

                gasCounterList: gasCounterList,
                boilerList: boilerList,
                waterHeaterList: waterHeaterList,
                stoveList: stoveList,

                nextCheckupDate: this.shelters.nextCheckupDate.value
            }
        },
        setProfileAttributes() {
            const attributes = {
                fname: this.shelters.ownerName.value,
                lname: this.shelters.ownerLastName.value,
                pname: this.shelters.ownerMiddleName.value,
                email: this.shelters.ownerEmail.value,
                phone: this.clearPhoneNumber(this.shelters.ownerPhone.value)
            }

            return attributes
        },
        saveShelter() {
            this.$axios.post('profiles', {
                data: {
                    type: 'profile',
                    attributes: this.setProfileAttributes()
                }
            }, this.loading = true)
            .then((response) => {                                
                let attributes = this.setAttributes()
                attributes.bid = this.$route.params.id
                attributes.profid = response.data.data.id

                return this.$axios.post('property', {
                    data: {
                        type: 'property',
                        attributes: attributes
                    }
                }, this.loading = true)
                .then(response => {
                    setTimeout(() => {
                        this.loading = false
                        this.$store.dispatch('modalNotificationMessageOpen', ['Помещение сохранено'])
                        this.showShelterEdit = false
                        this.saved = true
                    }, 1000)
                })
            })
            .catch(err => {
                console.log('Ошибка добавления: ', err)
            })
        },
        editShelter() {
            let sid = ''
            let profid = ''
            let bid = ''

            if (this.single) {
                profid = this.shelters.profid
                sid = this.$route.params.id
                bid = this.shelters.bid
            }            
            if (this.items.attributes) {
                profid = this.items.attributes.profid
                sid = this.items.id
                bid = this.items.attributes.bid
            }

            this.$axios.patch('profiles/' + profid, {
                data: {
                    type: 'profile',
                    attributes:  this.setProfileAttributes()
                }
            }, this.loading = true)
            .then((response) => { 
                let attributes = this.setAttributes()
                attributes.bid = bid
                attributes.profid = profid

                return this.$axios.patch('property/' + sid, {
                    data: {
                        type: 'property',
                        attributes: attributes
                    }
                }, this.loading = true)
                .then(response => {        
                    setTimeout(() => {
                        this.loading = false
                        this.$store.dispatch('modalNotificationMessageOpen', ['Данные о помещении изменены'])
                        this.saved = true
                    }, 1000)
                })
            })
            .catch(err => {
                console.log('Ошибка редактирования: ', err)
            })
        },
        setConstruction() {
            if (!this.shelters.constructionList.length) {
                //Чекбоксы материалы при создании нового помещения
                this.shelters.constructionList = JSON.parse(JSON.stringify(this.$store.getters['filtersBuildingMaterial']))
            }
        }
    },
    watch: {
        itemsComputed: function(newVal) {
            this.$store.dispatch('addressesGetUser', this.itemsComputed.attributes.profid)
                .then(() => {                    
                    this.getProfileAttributes(this.$store.getters['addressesUser'])
                })
        }
    }
}
</script>